import apiRequest from '@/services/api-request.js';

export default {
  namespaced: true,
  state: {
    configuration: null,
  },
  mutations: {
    setConfiguration(state, payload) {
      state.configuration = payload;
    },
  },
  actions: {
    async fetchRecommendedWorkflowsConfiguration({ commit, state }) {
        if (state.config) return;

        const config = await apiRequest(`/wfc/wc-workflows.json`, 'get');

        if (!config) throw `No workflows config`;

        commit('setConfiguration', config);

        return config;
    },
  },
  getters: {
    getWorkflowsByContextId: (state) => (contextId) => {
      const config = state?.configuration;

      return config ? config[contextId]?.workflows : null;
    },
    getWorkflowsTitleByContextId: (state) => (contextId) => {
      const config = state?.configuration;

      return config && config[contextId] ? config[contextId]?.title : 'What other researchers are looking for:';
    },
  } 
};
